var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsUpStrokeStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 20.5L3 20.5C2.44771 20.5 2 20.0522 2 19.5V11.5C2 10.9477 2.44772 10.5 3 10.5H7",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9477 20.5H7V10.5L13.9158 3.49997L13.9867 3.57177C15.432 5.03467 15.8379 7.24745 15.0078 9.13799L14.4098 10.5H20.0224C21.3836 10.5 22.3371 11.8603 21.8874 13.1607L19.8127 19.1607C19.5353 19.9628 18.7874 20.5 17.9477 20.5Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpStrokeStandard);
export default __webpack_public_path__ + "static/media/thumbs-up-stroke-standard.082fc171d19ce13d53639e82eabfd1f3.svg";
export { ForwardRef as ReactComponent };